export const SUB_NAV_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.GalleryTemplateInterface.SubNavTemplate';
